<div class="gaming_section" id="gaming">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6 text-center pe-lg-5 pe-md-4">
        <iframe width="100%" height="400" src="https://www.youtube.com/embed/1VDyO2W94qw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>         
        </div>
        <div class="col-lg-6 col-md-6 ps-lg-5 pe-md-4">
          <div class="common_home_section">
            <h2>NFT Gaming Platform</h2>
            <p>A cornerstone of the project is our innovative Play to Earn gaming platform.  Guided by the retro 8 bit styling of the Dogs of Elon NFTs, we are creating an addictive and fun gaming experience that employs the NFT collection and the DOE token at its core.<br/><br/>
              There are currently two different and unique games being developed and tested by the team.  Check out the future of NFT gaming! 
            </p>
            <div class="btn_group">                   
              <a href="https://medium.com/dogs-of-elon-community/dogs-of-elon-to-develop-a-gaming-platform-e71cf8955903" target="_blank" class="fill_btn">Learn More</a>
            </div>
          </div>
        </div>            
      </div>
    </div>
  </div>